import { Component, Input,EventEmitter, OnInit, Output } from '@angular/core';
import { CalendarEventModel } from 'src/app/shared/component/weekly-calendar/calendar-event-model';


@Component({
  selector: 'app-calendar-day',
  templateUrl: './calendar-day.component.html',
  styleUrls: ['./calendar-day.component.scss']
})
export class CalendarDayComponent implements OnInit {
  @Input() dateObj : any;
  @Output() selectedEvent = new EventEmitter<CalendarEventModel>()

  constructor() { }

  ngOnInit(): void {
  }

  eventSelected(event:CalendarEventModel){
    this.selectedEvent.emit(event);
  }

}
